import ModelTypeConstants from 'constants/ModelTypeConstants';
import {UnknownNoteLinkedGroup} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import {NotePart} from 'notebook/util/NoteUtilConstants';

import getNotePartType from './getNotePartType';

interface InspectNotePartsOptions {
  recurseIntoNoteLinkedGroups?: boolean;
}

export default function inspectAllNoteParts(
  noteParts: Array<NotePart>,
  callback: (notePart: NotePart) => void,
  options: InspectNotePartsOptions = {recurseIntoNoteLinkedGroups: true}
): void {
  for (const notePart of noteParts) {
    callback(notePart);
    if (
      options.recurseIntoNoteLinkedGroups &&
      getNotePartType(notePart) === ModelTypeConstants.NOTE_LINKED_GROUP
    ) {
      const noteLinkedGroup = notePart.item as UnknownNoteLinkedGroup;
      inspectAllNoteParts(noteLinkedGroup.containedNoteParts, callback, options);
    }
  }
}
